<a mat-list-item (click)="toggle()" style="width: fit-content;">
    <div fxLayout="row" fxLayoutAlign="space-between stretch" [ngClass]="{'expandido': menuPrincipalService.expandido}"
        class="submenu">
        <div fxLayout="row" fxLayoutAlign="start stretch" matTooltip="Tabelas de Referência">
            <mat-icon>table_chart</mat-icon>
            <span *ngIf="menuPrincipalService.expandido" class="nav-caption">Tabelas de Referência</span>
        </div>
        <div fxLayout="row" fxLayoutAlign="start stretch">
            <mat-icon *ngIf="menuPrincipalService.expandido" style="padding-top: 2px">{{getIcone()}}</mat-icon>
        </div>
    </div>
</a>

<mat-nav-list [ngClass]="{'expandido': menuPrincipalService.expandido}">

    <div [hidden]="!isMostrarSubMenu" [@menuState]="currentState">

        <!-- NIVEIS TURMAS -->
        <div style="padding-left: 15px">
            <sub-menu *ngIf="verificaAcesso(getModulos().NIVEIS_TURMAS)" icone="timeline" titulo="Níveis de turmas" 
            rota="niveisturmas" toolTip="Níveis de Turmas"></sub-menu>
        </div>

        <!-- PERIODO ATIVIDADE -->
        <div style="padding-left: 15px">
            <sub-menu *ngIf="verificaAcesso(getModulos().PERIODO_ATIVIDADE)" icone="date_range" titulo="Períodos de Atividades" 
            rota="periodoatividade" toolTip="Períodos de Atividades"></sub-menu>
        </div>

        <!-- AVALIACAO ATIVIDADE -->
        <div style="padding-left: 15px">
            <sub-menu *ngIf="verificaAcesso(getModulos().AVALIACAO_ATIVIDADE)" icone="done_all"
            titulo="Tipos de Avaliações" rota="avaliacaoatividade" toolTip="Tipos de Avaliações"></sub-menu>
        </div>

        <!-- TIPO_OCORRENCIA_ALUNO -->
        <div style="padding-left: 15px">
            <sub-menu *ngIf="verificaAcesso(getModulos().TIPO_OCORRENCIA_ALUNO)" icone="block" titulo="Tipos de ocorrências"
            rota="tipoocorrenciaaluno" toolTip="Tipos de ocorrências"></sub-menu>
        </div>
        
        <!-- TIPOS_ATIVIDADES -->
        <div style="padding-left: 15px">
            <sub-menu *ngIf="verificaAcesso(getModulos().TIPOS_ATIVIDADES)" icone="list" titulo="Tipos de atividades"
            rota="tiposatividades" toolTip="Tipos de atividades"></sub-menu>
        </div>
        
        <!-- MOTIVO DESLIGAMENTO -->
        <div style="padding-left: 15px">
            <sub-menu *ngIf="verificaAcesso(getModulos().MOTIVOS_DESLIGAMENTOS)" icone="web_asset_off" titulo="Motivos Desligamentos"
            rota="motivosdesligamentos" toolTip="Motivos Desligamentos"></sub-menu>
        </div>

        <!-- PUBLICO PRIORITARIO -->
        <div style="padding-left: 15px">
            <sub-menu *ngIf="verificaAcesso(getModulos().TIPOS_PUBLICOS_PRIORITARIOS)" icone="done" titulo="Público Prioritário"
            rota="tipospublicoprioritario" toolTip="Público Prioritário"></sub-menu>
        </div>


    </div>
</mat-nav-list>
